import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetInvestigationSampleCollectedFromList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/InvestigationSampleCollectedFrom/GetList?` + params, null);
  
export const GetInvestigationSampleCollectedFromDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/InvestigationSampleCollectedFrom/GetDetail?` + params, null);

export const CreateInvestigationSampleCollectedFrom = (data: any) =>
  POST_ENC(`${BASE_URL}/api/InvestigationSampleCollectedFrom/Create`, data);

export const UpdateInvestigationSampleCollectedFrom = (data: any) =>
  POST_ENC(`${BASE_URL}/api/InvestigationSampleCollectedFrom/Update`, data);    

export const DeleteInvestigationSampleCollectedFrom = (data: any) =>
  POST_ENC(`${BASE_URL}/api/InvestigationSampleCollectedFrom/Delete`, data);